import React from "react";

const arya_kulkarni = () => {
  return (
    <div>
      <h1>Arya Kulkarni</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Students were shortlisted for interviews based on an Aptitude Round.
        Eligibility for this round required a minimum CGPA of 7.5.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The aptitude test was conducted at the beginning of the month, followed
        by our mid-semester exams. The results of the aptitude test were
        announced during the mid-semester period. Interviews were held
        immediately after the mid-semester exams, and the results of these
        interviews were released on the same day.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The assessment comprised four timed sections. The initial section
        featured a single coding question. This was followed by multiple-choice
        questions in English and Finance. The English section was manageable
        within the allocated time, however, completing the finance section was a
        challenge due to time limitations. The final section contained two
        straightforward coding questions.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        25
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />3 days, brushed up the concepts from oop, co, dsa, ml, os, dbms.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        The online aptitude was followed by 3 rounds comprising two technical
        and one HR round. Technical Round 1 had certain DSA based questions
        which were relatively simple like queue implementation using stack,
        removing duplicate elements from arraylist using hashset(is hashset in
        java thread safe?) , greedy based questions like interview scheduling
        based on interval, . Also there was a brief project related discussion
        including tech stack,etc and certain SQL queries like altering data in
        the given table. Technical Round 2 was relatively tough compared to the
        first which started with extensive discussion on the project .Having a
        project pushed on github is generally ideal because my interview
        revolved around projects for a significant amount of time for around
        30-35 minutes of project discussion. After which discussion went towards
        SQL joins explaining all of them and relatively easy to medium DSA
        question based on find union minus intersection of 2 vectors, they also
        asked questions on low level memory like Cache locality, cache divided
        in two part instruction and data, which cache level is same across
        multiple cpus, then some questions on ROM, RAM, SDD, HD. Explaining club
        projects here helps as they like an “all-round engineer”. HR round was
        relatively easier and included certain basic questions like why Wells
        Fargo and setbacks in life and how to cope up with them. Out of 25
        almost 14 students were shortlisted for technical 2 followed by HR of
        all of them. 10 students received the final offer.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        OOP, OS, DBMS, Puzzles
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Love babbar,Striver A to Z, GFG puzzle, Apna College
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice and familiarity.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Project is definitely a good part of interview discussion not just in
        Wells Fargo but in most of the company interviews .So having a good
        project in the resume definitely helps and more importantly if you have
        done it yourself and know all the intricate details of the same that
        would definitely make a strong case for you. Apart from that,
        extra-curricular activities are also very important. E.g. if there was
        an issue with the technical part of your interview, maybe you were not
        able to explain some concepts etc. They look at your other qualities,
        your social internship where you actually contribute to society, if you
        are a state/National player in any sport these things add to your
        portfolio of being an “allround engineer”
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Be confident.
        <br />
        Getting a good Aptitude score puts you in a better position for the
        interview.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Start the preparation as early as possible.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:aryafirstone1@gmail.com">aryafirstone1@gmail.com</a>
      </p>

      <hr />
    </div>
  );
};

export default arya_kulkarni;
